import { staticFile } from 'remotion';

export const isRemoteMedia = (src: string): boolean =>
  src.startsWith('http://') ||
  src.startsWith('https://') ||
  src.startsWith('data:') ||
  src.startsWith('blob:');

export function normalizeLocalMediaPathForStaticFile(src: string): string {
  let value = src.trim();
  if (!value) return value;

  // If someone accidentally stored a filesystem-ish path (or included `public/`),
  // normalize it back to a Remotion/Next.js URL path.
  const marker = '/public/';
  const markerIndex = value.indexOf(marker);
  if (markerIndex !== -1) {
    value = value.slice(markerIndex + marker.length);
  }

  value = value.replace(/^public\//, '');
  // `staticFile()` expects a path relative to `public/`, without a leading slash.
  value = value.replace(/^\/+/, '');

  return value;
}

export function resolveMediaSrc(src: string): string {
  if (!src) return src;
  if (isRemoteMedia(src)) return src;

  const local = normalizeLocalMediaPathForStaticFile(src);
  // A local render loads this from its own file server, with no access check. The browser resolves
  // "." and ".." segments before asking and that server collapses empty ones, so either would load
  // a file other than the one named (another user's upload, say), which the file-reference check
  // on the saved spec never saw. No path the app stores has them. (A blank value stays as it was.)
  if (local && local.split('/').some((segment) => segment === '' || segment === '.' || segment === '..')) {
    throw new Error(`Unsupported media path "${src}": empty, "." and ".." segments are not allowed`);
  }
  return staticFile(local);
}


;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
